<div id="lista" class="page-layout carded fullwidth">
    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">
        <!-- HEADER -->
        <div
            class="header accent"
            fxLayout="column"
            fxLayoutAlign="center center"
            fxLayout.gt-sm="row"
            fxLayoutAlign.gt-sm="space-between center"
        >
            <!-- APP TITLE -->
            <div class="logo mb-24 mb-md-0" fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="logo-icon s-32 mr-16">business</mat-icon>
                <span class="logo-text h1">
                    Lista de Atividades do {{ is_assessor ? "Assessor" : "Especialista" }}
                </span>

                <!-- Botão de adicionar -->
                <button mat-mini-fab color="warning" style="margin-left: 10px" (click)="openCadastro()">
                    <mat-icon>add_circle</mat-icon>
                </button>

                <!-- Botão de consultar -->
                <button
                    mat-mini-fab
                    color="warning"
                    style="margin-left: 10px"
                    matTooltip="Consultar"
                    (click)="openFiltro()"
                >
                    <mat-icon>search</mat-icon>
                </button>

                <!-- Botão de exportar -->
                <button
                    mat-mini-fab
                    color="warning"
                    style="margin-left: 10px"
                    matTooltip="Exportar Gestão de Relacionamento"
                    (click)="exportar()"
                    *ngIf="this._actions.buttonExport.enabled"
                >
                    <mat-icon>cloud_download</mat-icon>
                </button>

                <!-- Botão de filtrar por prioridade -->
                <div
                    [matBadgeHidden]="length_priority === 0"
                    [matBadge]="length_priority"
                    matBadgeOverlap="true"
                    matBadgeColor="warn"
                    *ngIf="is_assessor"
                >
                    <button
                        mat-mini-fab
                        color="warning"
                        class="priority-button"
                        matTooltip="Filtrar Ações Prioritárias"
                        (click)="togglePriority()"
                        style="margin-left: 10px"
                        [ngClass]="{ active: is_priority }"
                    >
                        <mat-icon>priority_high</mat-icon>
                    </button>
                </div>

                <button
                    class="warn"
                    mat-mini-fab
                    style="margin-left: 10px"
                    matTooltip="Limpar Filtro"
                    (click)="resetFilters()"
                    *ngIf="isFiltered"
                >
                    <mat-icon>clear</mat-icon>
                </button>
            </div>
        </div>

        <div class="content-card">
            <div class="table-wrapper">
                <table mat-table [dataSource]="rows" class="mat-elevation-z8" matSort fxFlex="100">
                    <!-- data_hora_atividade -->
                    <ng-container matColumnDef="data_hora_atividade">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            class="sticky-col sticky-data"
                            (click)="onSort('data_hora_atividade')"
                        >
                            Data
                        </th>
                        <td mat-cell *matCellDef="let element" class="sticky-col sticky-data">
                            {{ element.data_hora_atividade | date: "dd/MM/yyyy" }}
                        </td>
                    </ng-container>

                    <!-- Assessor -->
                    <ng-container matColumnDef="nome_assessor" *ngIf="usuario.role_id != UserRole.SOCIO_ASSESSOR">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            class="sticky-col sticky-assessor sticky-default"
                            (click)="onSort('assessor')"
                        >
                            Assessor
                        </th>
                        <td mat-cell *matCellDef="let element" class="sticky-col sticky-assessor sticky-default">
                            <div fxLayout="column">
                                <span> {{ element.nome_escritorio }}</span>
                                <span> {{ element.nome_assessor }}</span>
                            </div>
                        </td>
                    </ng-container>

                    <!-- Cliente -->
                    <ng-container matColumnDef="cliente_nome">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            class="sticky-col sticky-cliente sticky-default"
                            (click)="onSort('cliente')"
                        >
                            Cliente
                        </th>
                        <td mat-cell *matCellDef="let element" class="sticky-col sticky-cliente sticky-default">
                            <div fxLayout="column">
                                <span [style.cursor]="element.cliente_id ? 'pointer' : 'default'" (click)="redirecionaCliente(element.cliente_id)">
                                    {{ element.cliente_numero_xp }}</span
                                >
                                <span [style.cursor]="element.cliente_id ? 'pointer' : 'default'" (click)="redirecionaCliente(element.cliente_id)">
                                    {{ element.cliente_nome }}
                                </span>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="especialista">
                        <th mat-header-cell *matHeaderCellDef class="sticky-col sticky-especialista sticky-default">
                            Preenchido Por
                        </th>
                        <td mat-cell *matCellDef="let element" class="sticky-col sticky-especialista sticky-default">
                            <div fxLayout="column" *ngIf="element.tarefas_respostas_usuarios">
                                {{ element.tarefas_respostas_usuarios.usuario.name }}
                            </div>
                        </td>
                    </ng-container>

                    <!-- Assunto -->
                    <ng-container matColumnDef="nome_assunto">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            class="sticky-col sticky-assessor sticky-default"
                            (click)="onSort('nome_assunto')"
                        >
                            Assunto
                        </th>
                        <td mat-cell *matCellDef="let element" class="sticky-col sticky-assessor sticky-default">
                            {{ element.nome_assunto }}
                        </td>
                    </ng-container>

                    <!-- Valor -->
                    <ng-container matColumnDef="valor_sugerido">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            class="sticky-default"
                            style="width: 150px"
                            (click)="onSort('valor_sugerido')"
                        >
                            Valor
                        </th>
                        <td mat-cell *matCellDef="let element" class="sticky-default" style="width: 150px">
                            R$ {{ (element.valor_sugerido ? element.valor_sugerido : 0) | number: "1.2-2" }}
                        </td>
                    </ng-container>

                    <!-- Observacao -->
                    <ng-container matColumnDef="observacao">
                        <th mat-header-cell *matHeaderCellDef class="sticky-default" style="width: 300px">
                            Observação
                        </th>
                        <td mat-cell *matCellDef="let element" class="sticky-default" style="width: 300px">
                            {{ element.observacao }}
                        </td>
                    </ng-container>

                    <!-- Servico -->
                    <ng-container matColumnDef="servico">
                        <th mat-header-cell *matHeaderCellDef class="sticky-default" style="width: 300px">Serviço</th>
                        <td mat-cell *matCellDef="let element" class="sticky-default" style="width: 300px">
                            {{ element.servico?.nome }}
                        </td>
                    </ng-container>

                    <!-- Registro de Contato -->
                    <ng-container matColumnDef="registro_contato">
                        <th mat-header-cell *matHeaderCellDef class="sticky-default" style="width: 300px">
                            Registro de Contato
                        </th>
                        <td mat-cell *matCellDef="let element" class="sticky-default" style="width: 300px">
                            <div fxLayout="column" *ngIf="element.tarefas_respostas_usuarios">
                                <span class="texto"
                                    ><strong>cliente aceitou:</strong> {{ element.cliente_aceitou ? "Sim" : "Não" }}
                                </span>
                                <span class="texto">
                                    <strong>data resposta:</strong>
                                    {{ element.tarefas_respostas_usuarios.updated_at | date: "dd/MM/yyyy" }}
                                </span>
                                <span class="texto">
                                    <strong>valor:</strong> R$
                                    {{ element.tarefas_respostas_usuarios.valor | number: "1.2-2" }}
                                </span>
                                <span class="texto">
                                    <strong>resposta:</strong> {{ element.tarefas_respostas_usuarios.resposta }}
                                </span>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="arquivos">
                        <th mat-header-cell *matHeaderCellDef class="sticky-default" style="width: 100px">Arquivos</th>
                        <td mat-cell *matCellDef="let element" class="sticky-default">
                            <button
                                mat-icon-button
                                *ngIf="element.arquivos && element.arquivos.length > 0"
                                (click)="openViewFiles(element)"
                            >
                                <mat-icon>attachment</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="acao">
                        <th mat-header-cell *matHeaderCellDef class="sticky-acao sticky-default">Ação</th>
                        <td mat-cell *matCellDef="let element" class="sticky-acao sticky-default">
                            <button mat-icon-button [matMenuTriggerFor]="actions" matTooltip="Mostrar Opções">
                                <mat-icon>more_horiz</mat-icon>
                            </button>
                            <!-- / ADD BUTTON -->
                            <mat-menu #actions="matMenu">
                                <button
                                    mat-menu-item
                                    matTooltip="Editar Observação"
                                    (click)="openAlterar(element.id)"
                                    *ngIf="usuario.role_id == UserRole.ADMINISTRADOR_SISTEMAS"
                                >
                                    <mat-icon aria-label="Editar">edit</mat-icon>
                                    EDITAR OBSERVAÇÃO
                                </button>
                                <button
                                    mat-menu-item
                                    matTooltip="Resposta Especialista"
                                    (click)="openRespostaEspecialista(element)"
                                    *ngIf="element.tarefas_respostas_usuarios"
                                >
                                    <mat-icon aria-label="Editar">add</mat-icon>
                                    RESPOSTA ESPECIALISTA
                                </button>
                                <button
                                    mat-menu-item
                                    matTooltip="Registrar Contato"
                                    (click)="openRegistroContato(element)"
                                    *ngIf="this._actions.buttonEdit.enabled && element.resposta == null"
                                >
                                    <mat-icon aria-label="Registrar Contato">edit</mat-icon>
                                    REGISTRAR CONTATO
                                </button>
                                <button
                                    mat-menu-item
                                    matTooltip="Editar Contato"
                                    (click)="openRegistroContato(element)"
                                    *ngIf="this._actions.buttonEdit.enabled && element.resposta"
                                >
                                    <mat-icon aria-label="Editar">edit</mat-icon>
                                    EDITAR CONTATO
                                </button>
                                <button
                                    mat-menu-item
                                    matTooltip="Responder Atividade"
                                    (click)="openResponderAtividade(element)"
                                    *ngIf="_actions.buttonEdit.enabled && element.cliente_oportunidade_id != null"
                                >
                                    <mat-icon aria-label="Editar">edit</mat-icon>
                                    ATUAR NA OPORTUNIDADE
                                </button>
                                <button
                                    mat-menu-item
                                    matTooltip="Visualizar Arquivos"
                                    (click)="openViewFiles(element)"
                                    *ngIf="_actions.buttonListFiles.enabled"
                                >
                                    <mat-icon>attachment</mat-icon>
                                    ARQUIVOS
                                </button>
                                <button
                                    mat-menu-item
                                    matTooltip="Excluir Atividade"
                                    *ngIf="_actions.buttonDelete.enabled"
                                    (click)="delete(element.id)"
                                >
                                    <mat-icon aria-label="Excluir Cliente">delete</mat-icon>
                                    EXCLUIR
                                </button>
                            </mat-menu>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
            </div>

            <div style="padding: 5px 10px">
                <mat-paginator
                    #paginator
                    [length]="length"
                    [pageSize]="pageSize"
                    [pageSizeOptions]="pageSizeOptions"
                    (page)="pageEvent($event)"
                >
                </mat-paginator>
            </div>
        </div>
    </div>
</div>
